if (!window.customElements.get('subcategory-carousel')) {
  class SubcategoryCarousel extends HTMLElement {
    connectedCallback() {
      this._scrollArea = this.querySelector('.subcategory-list');
      this._buttons = Array.from(this.querySelectorAll('button[data-direction]'));

      if (!this._scrollArea) {
        return;
      }

      this._abortController = new AbortController();
      const signal = this._abortController.signal;

      this._buttons.forEach((button) => {
        button.addEventListener('click', () => {
          // Scroll by most of a viewport; CSS scroll-snap settles on a card edge,
          // so no per-card width math is needed for variable-width cards
          const direction = parseInt(button.dataset.direction, 10) * (this._isRtl ? -1 : 1);
          this._scrollArea.scrollBy({ left: direction * this._scrollArea.clientWidth * 0.8, behavior: 'smooth' });
        }, { signal });
      });

      const scrollEvent = 'onscrollend' in window ? 'scrollend' : 'scroll';
      this._scrollArea.addEventListener(scrollEvent, () => this._update(), { signal, passive: true });

      this._resizeObserver = new ResizeObserver(() => this._update());
      this._resizeObserver.observe(this._scrollArea);
    }

    disconnectedCallback() {
      this._abortController?.abort();
      this._resizeObserver?.disconnect();
    }

    get _isRtl() {
      return getComputedStyle(this).direction === 'rtl';
    }

    _update() {
      const scrollable = this._scrollArea.scrollWidth - this._scrollArea.clientWidth > 1;
      this._scrollArea.classList.toggle('is-scrollable', scrollable);

      const position = Math.abs(this._scrollArea.scrollLeft);
      const maxPosition = this._scrollArea.scrollWidth - this._scrollArea.clientWidth;

      this._buttons.forEach((button) => {
        const direction = parseInt(button.dataset.direction, 10);
        button.disabled = !scrollable || (direction < 0 ? position <= 1 : position >= maxPosition - 1);
      });
    }
  }

  window.customElements.define('subcategory-carousel', SubcategoryCarousel);
}
